import React, { Component } from 'react';
import Banner from './Banner';
import Enroll from './Enroll';
import Testimony from './Testimony';
import Unknown from './Unknown';
import Contacts from './Contacts';
import Footer from './Footer';
import Youtube from './Youtube';

import imagen from "../../../assets/img/image-001.jpg";
import CustomModalHome from "../../../components/Modal/CustomModalHome";

class Index extends Component {
    state = {
        open: true
    }

    constructor (props) {
        super (props);
        this.scrollIni();
    }

    scrollIni = () => {
        window.scroll({
            top: 0,
            behavior: 'smooth'
        });
    }

    modal = () => {
        let {open} = this.state;

        let contenidoModal = () => (
            <img src = {imagen} />
        )

        return (
            <CustomModalHome
                large = "medium"
                isopen =  {open}
                contenido = {contenidoModal()}
            />
        )
    }

    render() {
        return (
            <div style={{paddingLeft:0, paddingRight: 0}}>
                <Banner/>
                <Enroll/>
                <Testimony/>
                <Unknown/>
                {/* <Youtube videoId = "-b6btIf-0RI" titulo= "Registro de Estudiantes Regulares"
                descripcion = 'En esta seción podrás ver un video explicativo sobre el registro de estudiantes "REGULARES". Si deseas conocer los pasos para admisión debes esperar la publicación del video explicativo. Sigue los pasos que a continuación se muestran para poder comenzar a utilizar el sistema'/> */}
                <Contacts/>
                <Footer/>
                {/* this.modal() */}
            </div>
        );
    }
}
 
export default Index;


// WEBPACK FOOTER //
// ./src/site/Componentes/Index/Index.jsx